import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const pagetableColumnMultiselectProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
  bodyAlign: String as PropType<'left' | 'right' | 'center'>,
  name: String,
  width: [String, Number],
  fixed: [Boolean, String],
  tail: [Boolean, String],

  code: [String, Array] as PropType<string | { value: string; content: string }[]>,
})

export type PagetableColumnMultiselectProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumnMultiselectProps>>>

export default defineComponent({
  name: 'OPagetableColumnMultiselect',
  inheritAttrs: false,
  props: pagetableColumnMultiselectProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
